import React from 'react';
// TODO: long term, we should only load bodymovin on
// the 3-5 components/pages that use it.
import ReactBodymovin from 'react-bodymovin/lib/ReactBodymovinFull'
import OurWorkAnimation from '../pages/OurWork/OurWorkAnimation';
import OurApproachAnimation from '../pages/OurApproach/OurApproachAnimation';
import OurCompanyAnimation from '../pages/OurCompany/OurCompanyAnimation';
import { useHeroInfo } from '../util/queryFunctions';

//TODO: implement back button for page title below (browser history, <Pop go={-1}/> ?)

//TODO: pass bodymovin options only one pages that use it rather than
//loading it on all pages?
const ANIMATION_MAP = {
  '/our-work': OurWorkAnimation,
  '/our-approach': OurApproachAnimation,
  '/our-company': OurCompanyAnimation
}

function animation(location) {
  const animData = ANIMATION_MAP[location.pathname];
  if (!animData) return null;

  return (
    {
      container: document.getElementById('bodymovin'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animData
    }
  )
}

const InnerHero = ({ history, location, heroOverrides }) => {
  const { data, isFetching } = useHeroInfo();

  if (isFetching) return null;

  let locationData = data[location.pathname]

  if (heroOverrides) {
    locationData = heroOverrides
  } else if (location.pathname.endsWith('/')) {
    locationData = data[location.pathname.slice(0,-1)]
  }

  function renderBackButton() {
    let loc = location.pathname.split('/');
    let onClickFn = () => history.push("/");

    if (loc.length > 2) {
      onClickFn = () => history.push(`/${loc[1]}`);
    }

    return (
      <a onClick={onClickFn} className="hero-page-title">
        <i className="fa fa-arrow-left" aria-hidden="true"></i>
        <span>{locationData.heroTitle}</span>
      </a>
    );
  }

  return (
    <div className="shared-hero">
      {renderBackButton()}
      <div className="hero-wrap">
        <h1 className="hero-heading">
          {locationData.heroHeadline}
        </h1>
        <span className="hero-copy">
          {locationData.heroCopy}
        </span>
      </div>
    </div>
  );
};

const SharedHero = ({ history, location, heroOverrides }) => {
  return (
    <section className="hero-wrapper">
      <section className="container">
        <InnerHero history={history} location={location} heroOverrides={heroOverrides} />
      </section>
      <ReactBodymovin options={animation(location)} />
    </section>
  );
};

export default SharedHero;
